import { render, staticRenderFns } from "./bankPhoneField.vue?vue&type=template&id=230a3514&scoped=true"
import script from "./bankPhoneField.vue?vue&type=script&lang=js"
export * from "./bankPhoneField.vue?vue&type=script&lang=js"
import style0 from "./bankPhoneField.vue?vue&type=style&index=0&id=230a3514&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230a3514",
  null
  
)

export default component.exports